import clsx from 'clsx'

/** Decorative quilt blocks (white shapes on a theme colour square). */
const BLOCKS = {
  hourglass: 'M0 0h48L0 48z M48 0h48v48z M0 96V48l48 48z M96 96H48l48-48z',
  nine: 'M32 0h32v32H32z M0 32h32v32H0z M64 32h32v32H64z M32 64h32v32H32z',
  star: 'M48 8l10 30h30L64 56l10 30-26-18-26 18 10-30L8 38h30z',
  pinwheel: 'M48 48V0L0 0z M48 48h48V0z M48 48v48h48z M48 48H0v48z',
} as const

export type BlockName = keyof typeof BLOCKS

interface Props {
  block: BlockName
  /** Background: a theme block colour class, e.g. bg-qt-block-2. */
  color: string
  className?: string
}

export default function PatchworkBlock({ block, color, className }: Props) {
  return (
    <div className={clsx('flex items-center justify-center rounded-2xl', color, className)} aria-hidden="true">
      <svg viewBox="0 0 96 96" className="size-3/5">
        <path d={BLOCKS[block]} fill="#fff" fillOpacity="0.9" fillRule="evenodd" />
      </svg>
    </div>
  )
}
